import { render, staticRenderFns } from "./SimulationSantander.vue?vue&type=template&id=7ae5c58a&"
import script from "./SimulationSantander.js?vue&type=script&lang=js&"
export * from "./SimulationSantander.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports